module.exports = __webpack_public_path__ + "img/Hauskreis.293c349e.jpg";